import React, { useEffect } from 'react'
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
import { ACCOUNT_LIMIT } from '../../helpers/constants';
import { useDispatch, useSelector } from 'react-redux';
import { get_company_users } from '../../store/account/accountSlice';

const TablePaginationActions = (props) => {
    const theme = useTheme();
    let { count, page,rowsPerPage, onPageChange } = props;
    const totalPages = Math.ceil(count / rowsPerPage);
    const dispatch = useDispatch();
    const { defaultPage,selected_company,search_query } = useSelector((state) => state.account);

    useEffect(() => {
      if (defaultPage !== null){
        const qc = selected_company;
        const qn = search_query;
        const params = { page:page+1, limit: ACCOUNT_LIMIT };        
        if (qc) {
          params.qc = qc;
        } 
        if (qn) {
          params.qn = qn;
        }               
        dispatch(get_company_users(params));
      }
    },[defaultPage,page,selected_company, search_query,dispatch])  

    const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
    onPageChange(event,totalPages - 1);
    };
  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
        <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
        >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
        >
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
        </IconButton>
        <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= totalPages - 1}
        aria-label="next page"
        >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
        </IconButton>
        <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= totalPages - 1}
        aria-label="last page"
        >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
    </Box>
  )
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.any.isRequired,
    rowsPerPage: PropTypes.number.isRequired
};

export default TablePaginationActions;
